<template>
  <div
    :class="$style.image"
    :style="{
      backgroundImage,
      backgroundSize,
      width: width && width,
      height: height && height,
      paddingTop: height && '0px',
      borderRadius,
      border
    }"
    @click="$emit('click')"
  >
  </div>
</template>

<script>
import { computed } from 'vue'

export default {

  emits: [
    'click',
  ],
  setup (props) {
    const backgroundImage = computed(() => {
      return `url("${props.url}")`
    })

    return {
      backgroundImage,
    }
  },

  props: {
    url: {
      type: String,
      required: true,
    },
    backgroundSize: {
      type: String,
      default: 'contain',
    },
    width: {
      type: String,
      default: '100%',
    },
    height: {
      type: String,
    },
    borderRadius: {
      type: String,
    },
    border: {
      type: String,
    },
  },
}
</script>

<style lang="scss" module>
@layer legacy-views {

.image {
  padding-top: 56.25%;
  background-position: center center;
  background-repeat: no-repeat;
}

}</style>
